import { createSelector } from "reselect";
import { AppState } from "../rootReducer";

// GET targets 

const getTargetListPending = (state: AppState) => state.targets.pending;
const getTargetList = (state: AppState) => state.targets.targets;
const getTargetListError = (state: AppState) => state.targets.error;

export const getTargetListSelector = createSelector(getTargetList, (targets) => targets);
export const getTargetListPendingSelector = createSelector(getTargetListPending,(pending) => pending);
export const getTargetListErrorSelector = createSelector(getTargetListError, (error) => error);


// GET target

const getTargetDetailsPending = (state: AppState) => state.targetDetails.pending;
const getTargetDetails = (state: AppState) => state.targetDetails.target;
const getTargetDetailsError = (state: AppState) => state.targetDetails.error;

export const getTargetSelector = createSelector(getTargetDetails, (target) => target);
export const getTargetPendingSelector = createSelector(getTargetDetailsPending,(pending) => pending);
export const getTargetErrorSelector = createSelector(getTargetDetailsError, (error) => error);


// POST data target

const postDataPending = (state: AppState) => state.postDataTarget.pending;
const postDataTarget = (state: AppState) => state.postDataTarget.dataTarget;
const postDataError = (state: AppState) => state.postDataTarget.error;

export const postDataPendingSelector = createSelector(postDataPending, (pending) => pending);
export const postDataSelector = createSelector(postDataTarget, (dataTarget) => dataTarget);
export const postDataErrorSelector = createSelector(postDataError, (error) => error);

// PUT data target

const putDataPending = (state: AppState) => state.putDataTarget.pending;
const putDataTarget = (state: AppState) => state.putDataTarget.dataTarget;
const putDataError = (state: AppState) => state.putDataTarget.error;

export const putDataPendingSelector = createSelector(putDataPending, (pending) => pending);
export const putDataSelector = createSelector(putDataTarget, (dataTarget) => dataTarget);
export const putDataErrorSelector = createSelector(putDataError, (error) => error);

// DELETE target

const deleteTargetPending = (state: AppState) => state.deleteDataTarget.pending;
const deleteTarget = (state: AppState) => state.deleteDataTarget.success;
const deleteTargetError = (state: AppState) => state.deleteDataTarget.error;

export const deleteTargetSelector = createSelector(deleteTarget, (target) => target);
export const deleteTargetPendingSelector = createSelector(deleteTargetPending,(pending) => pending);
export const deleteTargetErrorSelector = createSelector(deleteTargetError, (error) => error);


